import { ITranslator } from '../aggr_module/translators/itranslator';
import { IClientConfig } from '../aggr_module/data_manager/data_manager_factory';
// import logger from 'logger_module';

export class Util {
    
    static getUUID(): string {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    static prepareParamString(obj: any, exludeKeys: string[]) {
        return Object.keys(obj).map((key, index) => {
            if (!(exludeKeys && exludeKeys.indexOf(key) !== -1)) {
                if(index == 0){
                    return key + '=' + obj[key];
                }else{
                    return "&"+ key + '=' + obj[key];
                }                
            }
        }).join('');
    }
    static getValue = function (arr: any[], key: any) {
        if (arr != undefined && key != undefined) {
            for (var i = 0; i < arr.length; i++) {
                var obj = arr[i]
                if (obj.key == key) {
                    return (obj.value && obj.value.toString()) || '';
                }
            }
        }
        return '';
    }
    static isValidUrl(url: string): boolean {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    }
    // TODO: move list of entries to config
    static isValidUrlForBaseDomainConvertion(url: string): boolean {
        return window.location.href.indexOf('cvs.com') === -1 && url.indexOf('/cart') === -1;
    }
    /**
     *Method to get the translator object if present,
     *else throw an error.
     * @static
     * @param {IClientConfig} config
     * @returns {ITranslator}
     * @memberof Util
     */
    static getTranslatorObj(config: IClientConfig): ITranslator {
        if (!config.translator)
            throw new Error("translator object not present");

        return config.translator;
    }
    static getHostDomain(): string {
        return (window.location.href.indexOf('cvs.com') === -1) ? document.location.hostname : document.location.hostname + '/photo';
    }

    // Returns {'X-API-Key': <key>} when Apigee routing is enabled (photoOrg.config.xApiKey populated
    // server-side off the enable_x_api_key flag), else {} so callers can always spread/merge it safely.
    static getXApiKeyHeader(): Record<string, string> {
        try {
            //@ts-ignore
            const apiKey = photoOrg && photoOrg.config && photoOrg.config.xApiKey;
            return apiKey ? { 'X-API-Key': apiKey } : {};
        } catch (e) {
            return {};
        }
    }

    /**
     * converts given url hostname to base domain hostname
     * @param url
     * @returns {XML|*|string|void}
     */
    static convertToBaseDomainHostNameUrl(url: string, replacedDomain: string) {
        // URL class is not supported in IE browser versions to extract domain in given url argument
        const parseddomain = url.split('/')[2];

        // For a particular website an extra string needs to be added to the hostname.
        return url.replace(parseddomain, replacedDomain);
    }

    static maskpII(rObject: any) {

        if (rObject) {
            try {
                if (typeof rObject === 'string') {
                    rObject = JSON.parse(rObject);
                }
            } catch (e) {
                rObject = 'xxxx';
                return rObject;
            }
        }

        for (const key in rObject) {
            try {
                if ((key.toString().toLowerCase().indexOf('name') !== -1) ||
                    (key.toString().toLowerCase().indexOf('mail') !== -1) ||
                    (key.toString().indexOf('guid') !== -1)
                    || (key.toString() === ('data') && typeof rObject[key] !== 'object')) {
                    rObject[key] = 'xxxx';
                    console.log(key + ' , ' + rObject[key]);
                }
                if (typeof rObject[key] === 'object') {
                    if (rObject[key] && rObject[key].data) {
                        rObject[key] = 'xxxx';
                    }
                    rObject[key] = Util.maskpII(rObject[key]);
                }
            } catch (e) {
                //@ts-ignore
                photoOrg.clientLogger && photoOrg.clientLogger.error(rObject);
            }
        }
        return rObject;
    }

    private static s4(): string {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    /**
     * Method used to get the list of album ids from picture parent collection references
     * @param parentCollectionReferences 
     */
    static getAlbumIds(parentCollectionReferences:any): Array<string>{
        let albumList = []
        //@ts-ignore
        //photoOrg.clientLogger && photoOrg.clientLogger.debug("abcd");
        if(parentCollectionReferences && parentCollectionReferences.length > 0){
            albumList = parentCollectionReferences.map((obj:any) => obj.collectionId.toString());
        }
        return albumList;
    }  
    /* istanbul ignore next */
    static getCurrentTime(): any{
        return new Date().getTime();
    }
    // static getAjxhelperObj = function(config: any){
    //     return new AjaxHelper(config);
    // }
}